// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getLaborRateChanges} from '../../shared/repositories';

export const readLaborRateChanges = selectedAccounts =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const laborRateChanges = await getLaborRateChanges(selectedAccounts);

            dispatch({
                data: laborRateChanges,
                length: laborRateChanges.length,
                type: actions.UPDATE_TCSM_LABOR_RATE_CHANGES
            });

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/get-labor-rate-changes.js